document.addEventListener('DOMContentLoaded', function() {
  // Función para abrir el carrito
  function openCartDrawer() {
    const cartDrawer = document.querySelector(".cart-drawer");
    if (cartDrawer) {
      cartDrawer.classList.add("cart-drawer--active");
      document.body.style.overflow = "hidden"; // Añadir overflow hidden al body
    } else {
      console.error("Cart drawer not found!");
    }
  }

  // Función para cerrar el carrito
  function closeCartDrawer() {
    const cartDrawer = document.querySelector(".cart-drawer");
    if (cartDrawer) {
      cartDrawer.classList.remove("cart-drawer--active");
      document.body.style.overflow = ""; // Remover overflow hidden del body
    } else {
      console.error("Cart drawer not found!");
    }
  }

  // Función para actualizar el conteo de items del carrito
  function updateCartItemCounts(count) {
    document.querySelectorAll(".cart-count").forEach((el) => {
      el.textContent = count;
    });
  }

  // Función para actualizar el drawer del carrito
 async function updateCartDrawer() {
    try {
      const res = await fetch("/?section_id=cart-drawer");
      const text = await res.text();
      const html = document.createElement("div");
      html.innerHTML = text;

      const cartDrawer = document.querySelector(".cart-drawer");
      if (cartDrawer) {
        const newBox = html.querySelector(".cart-drawer");
        if (newBox) {
          cartDrawer.innerHTML = newBox.innerHTML;
        } else {
          console.error("New cart drawer content not found in fetched HTML");
        }
      } else {
        console.error("Cart drawer not found in the document");
      }

      // Vuelve a añadir los listeners tras actualizar el carrito
      addCartDrawerListeners();
    } catch (error) {
      console.error("Error updating cart drawer:", error);
    }
  }

  // Añadir listeners a los botones de cantidad, remover y cerrar
  function addCartDrawerListeners() {
    // Listener para actualizar cantidades
    document.querySelectorAll(".cart-drawer-quantity-selector button").forEach((button) => {
      button.addEventListener("click", async () => {
        const rootItem = button.closest('.cart-drawer-item');
        const key = rootItem.getAttribute("data-line-item-key");

        const currentQuantity = Number(button.parentElement.querySelector("input").value);
        const isUp = button.classList.contains("cart-drawer-quantity-selector-plus");
        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();

        updateCartItemCounts(cart.item_count);

        // Actualiza el drawer
        updateCartDrawer();
      });
    });

    
    // Listener para remover items del carrito
    document.querySelectorAll(".cart-drawer-item-remove").forEach((button) => {
      button.addEventListener("click", async () => {
        const key = button.getAttribute("data-line-item-key");

        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: 0 } }),
        });
        const cart = await res.json();

        updateCartItemCounts(cart.item_count);

        // Actualiza el drawer
        updateCartDrawer();
      });
    });

    // Evitar que el carrito se cierre al hacer clic dentro del contenido
    document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
      e.stopPropagation();
    });

    // Listener para cerrar el carrito (si se hace clic fuera del contenido)
    document.querySelector(".cart-drawer").addEventListener("click", (e) => {
      if (!e.target.closest('.cart-drawer-box')) {
        closeCartDrawer();
      }
    });

    // Listener para el botón de cerrar el carrito
    document.querySelector(".cart-drawer-header-right-close").addEventListener("click", () => {
      closeCartDrawer();
    });
  }

  // Añadir listeners cuando la página carga
  addCartDrawerListeners();

  // Listener para añadir productos al carrito y abrir el drawer
  document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      await fetch("/cart/add", {
        method: "post",
        body: new FormData(form),
      });

      const res = await fetch("/cart.js");
      const cart = await res.json();
      updateCartItemCounts(cart.item_count);

      // Actualizar el drawer y abrirlo
      await updateCartDrawer();
      openCartDrawer();
    });
  });

  // Verificar si el cart-icon existe antes de añadir el listener
 const cartIcon = document.getElementById('cart-icon');
  if (cartIcon) {
    // Listener para abrir el carrito desde el icono del carrito
    cartIcon.addEventListener("click", async (e) => {
      e.preventDefault();
      e.stopPropagation(); // Detener la propagación del evento

      try {
        await updateCartDrawer(); // Actualiza el drawer antes de abrirlo
        openCartDrawer(); // Abrir el carrito
      } catch (error) {
        console.error("Error opening cart drawer:", error);
      }
    });
  } else {
    console.error("Cart icon not found!");
  }

  // Añadir un listener global para abrir el carrito
  document.addEventListener("click", function(e) {
    if (e.target.matches("#cart-icon, #cart-icon *")) {
      e.preventDefault();
      e.stopPropagation();
      
      updateCartDrawer().then(() => {
        openCartDrawer();
      }).catch((error) => {
        console.error("Error opening cart drawer:", error);
      });
    }
  });
});